"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaults = void 0;
var getDefaults = function (configuration) {
    var consumable = configuration.consumable, options = configuration.options, unlinkedOptions = configuration.unlinkedOptions, hasImage = configuration.hasImage, hasDescription = configuration.hasDescription, sellable = configuration.sellable, hasVariations = configuration.hasVariations, hasHours = configuration.hasHours, hasPos = configuration.hasPos, lists = configuration.lists;
    var standardDefaults = [
        {
            defaults: { image: null },
            test: hasImage,
        },
        {
            defaults: {
                amount: 0,
                tax: null,
                metadata: { quantitySold: 0, totalRevenue: 0 },
            },
            test: sellable,
        },
        {
            defaults: { description: '' },
            test: hasDescription,
        },
        {
            defaults: { variationGroups: [] },
            test: hasVariations,
        },
        {
            default: { pos: null },
            test: hasPos,
        },
        {
            defaults: {
                hours: [
                    'sunday',
                    'monday',
                    'tuesday',
                    'wednesday',
                    'thursday',
                    'friday',
                    'saturday',
                ].reduce(function (acc, day) {
                    var _a;
                    return Object.assign(acc, (_a = {}, _a[day] = { hours: [], open: true }, _a));
                }, {}),
            },
            test: hasHours,
        },
        {
            defaults: {
                allergens: [],
                glutenFree: false,
                vegetarian: false,
                alcohol: false,
                taxable: true,
            },
            test: consumable,
        },
    ].reduce(function (acc, _a) {
        var test = _a.test, defaults = _a.defaults;
        return (test ? Object.assign(acc, defaults) : acc);
    }, {});
    var defaultListsParams = {};
    var listDefaults = lists.reduce(function (acc, _a) {
        var _b;
        var name = _a.name;
        return (__assign(__assign({}, acc), (_b = {}, _b[name] = [], _b)));
    }, defaultListsParams);
    return __assign(__assign(__assign(__assign({ available: true, availableAt: null, brandLevelId: null, displayName: '', name: '' }, listDefaults), options), unlinkedOptions), standardDefaults);
};
exports.getDefaults = getDefaults;
//# sourceMappingURL=params.js.map